import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchMyLogins, type MyLoginPage } from './loginsApi'

/**
 * Kesh kaliti.
 *
 * ⚠️ `agentId` YO'Q va bo'lmasligi ham kerak: bu endpoint hisobning
 * O'ZIGA tegishli va identifikatorni tokendan oladi. Kalitga odam
 * identifikatorini qo'shish uni so'rovga ham qo'shish vasvasasini
 * tug'dirardi (`loginsApi.ts` boshidagi sabab). Sessiya almashganda
 * butun kesh baribir tozalanadi (`AuthProvider`).
 */
export const loginsKeys = {
  all: ['myLogins'] as const,
  page: (page: number) => ['myLogins', 'page', page] as const,
} as const

export interface MyLoginsState {
  page: MyLoginPage | null
  loading: boolean
  error: unknown
}

/**
 * O'z kirishlarim.
 *
 * ⚠️ `keepPreviousData` — sahifa almashganda ro'yxat BO'SHAB QOLMASIN:
 * usiz «Keyingi» bosilganda ekran skeletonga tushib, keyin qaytadan
 * to'lardi va odam qaysi sahifada ekanini yo'qotardi.
 *
 * ⚠️ `retry: false` — `useAgentOperations` bilan ayni sabab: qayta
 * urinish ekranni bir necha soniya «yuklanmoqda» da ushlab turadi,
 * xato esa baribir ko'rsatiladi.
 */
export function useMyLogins(page: number): MyLoginsState {
  const query = useQuery({
    queryKey: loginsKeys.page(page),
    queryFn: () => fetchMyLogins(page),
    placeholderData: keepPreviousData,
    retry: false,
  })

  return { page: query.data ?? null, loading: query.isPending, error: query.error }
}
